import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { setExceptionHandler } from '@app/store/actions';
import { vaultPasswordHistoryService } from '@app/services';
import { genericErrorString, passlyFormatDate, DATE_FORMAT } from '@app/helpers';
import { IVaultPasswordHistoryDisplay } from '@app/models';
import VaultPasswordComponent from '../components/vaultPassword.component';

export interface IReceivedData {
    vaultId: string;
    vaultPasswordId: string;
    vaultPasswordType: number;
}

export const ShowVaultPasswordHistoryDialog = (props: IReceivedData) => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [history, setHistory] = useState<IVaultPasswordHistoryDisplay[]>([]);

    useEffect(() => {
        dispatch(setExceptionHandler(true));

        let jsonObject: any = {};
        jsonObject.VaultPasswordId = props.vaultPasswordId;
        jsonObject.VaultPasswordType = props.vaultPasswordType;

        vaultPasswordHistoryService.getVaultPasswordHistory(jsonObject, props.vaultId, handleGetHistorySuccess, handleError);
    }, []);

    const handleGetHistorySuccess = (response: any) => {
        const results: IVaultPasswordHistoryDisplay[] = response.data.value;

        setHistory(results);
    };

    const handleError = (error: any) => {
        setErrorMessage(genericErrorString(error));
    };

    return (
        <>
            <div className='scrollableTable passwordVaults vaults__table-passwordsNoFlex passwordVaults__showHistoryBox'>
                {history.length === 0 ?
                    (
                        <div className='modal__header'>{translation('NO_PASSWORD_HISTORY')}</div>
                    )
                    : (
                        <>
                        <div className='vaults__table-passwords--wrapper vaults__table-passwords--wrapper--pwd'>
                            <span className='vaults__table-passwords--name'>{translation('CHANGED_DATE')}</span>
                            <span className='vaults__table-passwords--password'>{translation('PASSWORD')}</span>
                        </div>
                            {
                                history.map((row, index: number) => (
                                    <div className='vaults__table-passwords--wrapper vaults__table-passwords--wrapper--pwd'>
                                        <span className='vaults__table-passwords--name'>{passlyFormatDate(row.Created, DATE_FORMAT)}</span>
                                        <span className='vaults__table-passwords--password'>
                                            {<VaultPasswordComponent
                                                key={index + 'showHistory'}
                                                vaultId={props.vaultId}
                                                passwordId={row.Id}
                                                isHistoryPassword={true}
                                            />}
                                        </span>
                                    </div>
                                ))
                            }
                        </>
                    )}
            </div>


            {errorMessage !== undefined && errorMessage !== '' && <div className='modal__error'>{errorMessage}</div>}
        </>
    );
};
